import { createTheme as createMuiTheme } from "@mui/material/styles";
import "typeface-roboto";
//Limitless imports
import { customerBackground } from "@limitless/images";
import { COMMON_PALETTE } from "@limitless/common/utils";

/**
 * The Theme class overrides the default theme from Material UI
 *
 * The variable velow represents all of our overrides.
 *
 * A full list of variables that can be overriden can be found here and in ./MaterialDefaults.json
 * https://material-ui-next.com/customization/themes/#the-other-variables
 *  contrastText
 */
const defaultTheme = {
  palette: {
    ...COMMON_PALETTE,
    contrast: {
      light: "#fafafa",
      main: "#616161",
      text: "#616161"
    },
    dialogues: {
      ...COMMON_PALETTE.dialogues,
      expert: {
        background: "#0A2267",
        text: "#fff",
        borderRadius: 10
      },
      suggestedAnswer: {
        background: "#0A2267",
        text: "#fff",
        borderRadius: 10
      }
    }
  },
  background: {
    default: "#fafafa",
    paper: "#fff",
    appBar: "#f5f5f5",
    contentFrame: "#eeeeee",
    image: customerBackground
  },
  typography: {
    htmlFontSize: 16,
    fontFamily: "'Roboto', Helvetica, Arial, sans-serif",
    fontSize: 14,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500
  },
  components: {
    MuiTab: {
      styleOverrides: {
        root: {
          padding: "initial"
        }
      }
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          borderRadius: 0
        }
      }
    },
    MuiTypography: {
      defaultProps: {
        variant: "body2"
      }
    }
  },
  overrides: {
    MuiButton: {
      root: {
        textTransform: "none",
        borderRadius: 30
      }
    }
  }
};

/**
 * Create a theme with a value from the platform if available.
 *
 * Fallback to the default built-in theme
 *
 * @param {object} theme
 */
export const createTheme = theme => {
  if (theme === {} || !theme) {
    const customerTheme = createMuiTheme(defaultTheme);
    return customerTheme;
  }
  try {
    if (theme.typography.htmlFontSize === "auto") {
      let detectedFontSize = window.getComputedStyle(document.getElementsByTagName("html")[0]).getPropertyValue("font-size");
      detectedFontSize = detectedFontSize.replace("px", "");
      theme.typography.htmlFontSize = Number(detectedFontSize);
    }
  } catch (error) {
    //eslint-disable-next-line
    console.warn("Failed to auto detect font size, reverting to 16");
    theme.typography.htmlFontSize = 16;
  }
  return createMuiTheme(theme);
};

/**
 * Create a basic Theme object that will be stored in S3 and then used by the above.
 */
export const createLimitlessCustomerTheme = () => {
  const theme = defaultTheme;
  return theme;
};